import { Text } from '@enechain/ecloud-designsystem'

type Props = {
  children: React.ReactNode
  textAlign?: 'left' | 'right'
}

/**
 * 操作できないボタンの「押せない理由」を画面上に常時表示する注記。
 * docs/specs/conventions.md「操作できない時のボタンの扱い」。
 * 文末に句点を付けない・赤にしない・アイコンなし (design `.ecl-action-reason`)。
 */
export const ActionReasonText = ({
  children,
  textAlign,
}: Props): React.JSX.Element => (
  <Text textStyle="fieldHint" color="Text.midEmphasis" textAlign={textAlign}>
    {children}
  </Text>
)
